import { render, staticRenderFns } from "./ModalInformacoesUnidade.vue?vue&type=template&id=458eaee6"
import script from "./ModalInformacoesUnidade.vue?vue&type=script&lang=js"
export * from "./ModalInformacoesUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports